import { faLightbulb } from '@fortawesome/free-solid-svg-icons';

import SupportLink from '@/components/Support/SupportLink';

import { Props } from './types';

const SuggestionsLink = ({ originUrl }: Props) => {
  return (
    <SupportLink
      icon={faLightbulb}
      linkText="Suggestions"
      originUrl={originUrl}
      params={{ howCanWeHelp: 'I+have+an+idea+or+feature+request' }}
    />
  );
};

export default SuggestionsLink;
